import { useState } from "react";
import { ReactComponent as AddIcon } from "../../images/add.svg";

const LargeModal = props => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    if (props.onClose !== undefined) {
      try {
        setShow(false);
        props.onClose();
      } catch (error) {
        console.warn(`Function not provided to Large Modal onClose`);
      }
    }
  };

  if (!show) {
    return <></>;
  }

  return (
    <div className="large-modal">
      <div className="large-modal-wrapper">
        <div className="large-modal-close" onClick={handleClose}>
          <AddIcon style={{ transform: "rotate(45deg)" }} />
        </div>
        <div className="large-modal-content">{props.children}</div>
      </div>
    </div>
  );
};

export default LargeModal;
